export default "__VITE_ASSET__CDBwW0Sm__"